module.exports = __webpack_public_path__ + "static/media/FENCED_YARD_REQUIRED.d6fc067c.svg";